import React, { Suspense } from 'react';
import Layout from '../components/Layout';
import HeroSection from '../components/HeroSection';
import CurvedRibbon from '../components/CurvedRibbon';
import ClientsSection from '../components/ClientsSection';
import ContactSection from '../components/ContactSection';
import { 
  ServicesSection,
  ReferencesSection,
  TestimonialsSection
} from '../utils/lazyComponents';
import LoadingSpinner from '../components/LoadingSpinner';

const HomePage: React.FC = () => {
  return (
    <Layout
      title="StimmDigital | Softwareentwicklung aus Berlin"
      description="Stimm Digital GmbH & Co. KG - Dein Partner für Softwareentwicklung. Wir arbeiten direkt, schlank und persönlich. Entwicklung, Design und Umsetzung aus einer Hand."
      keywords="Softwareentwicklung, App-Entwicklung, Webentwicklung, Berlin, StimmDigital, Hybrid Software Development"
      includeReviewSchema={true}
    >
      <section>
        <HeroSection />

        {/* Content that scrolls over the hero */}
        <div style={{
          position: 'relative',
          zIndex: 10,
          marginTop: '0'
        }}>
          {/* Curved Ribbon - at the top of scrolling content */}
          <div style={{
            position: 'relative',
            zIndex: 50,
            width: '100%',
            marginTop: '-140px'
          }}>
            <CurvedRibbon />
          </div>

          <Suspense fallback={<LoadingSpinner />}>
            <ServicesSection />
          </Suspense>

          <ClientsSection />

          <Suspense fallback={<LoadingSpinner />}>
            <ReferencesSection />
          </Suspense>

          <Suspense fallback={<LoadingSpinner />}>
            <TestimonialsSection />
          </Suspense>

          <ContactSection />
        </div>
      </section>
    </Layout>
  );
};

export default HomePage;
